module.exports = __webpack_public_path__ + "static/media/glanum_bogen.cebdffde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_bogen.png
// module id = 711
// module chunks = 0